export default __webpack_public_path__ + "static/iso-edfaca7d521bb029c4036644d5276fd8.png";